import _schoolSltor from '@app/redux/school/school.selector';
import { useSelector } from 'react-redux';

export const useCurrentSchoolId = () => {
    const currentSchool = useSelector(_schoolSltor.currentSchool);

    return currentSchool;
};
